"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtiService = void 0;
var oti_integration_zendesk_service_1 = require("./services/oti-integration-zendesk.service");
var oti_integration_pendo_service_1 = require("./services/oti-integration-pendo.service");
var log_service_1 = require("./services/log.service");
var oti_integration_one_trust_service_1 = require("./services/oti-integration-one-trust.service");
var oti_integration_snowplow_1 = require("./services/oti-integration-snowplow");
var pub_sub_service_1 = require("./services/pub-sub.service");
var OtiService = /** @class */ (function () {
    function OtiService(options) {
        this.logService = new log_service_1.LogService();
        this.userChange$ = new pub_sub_service_1.PubSubService();
        this.options = options;
        if (options) {
            console.warn('OTIOptions send on constructor is deprecated, please use initialize method instead');
        }
        this.oneTrustIntegration = new oti_integration_one_trust_service_1.OtiIntegrationOneTrustService(this.logService);
        this.pendoIntegration = new oti_integration_pendo_service_1.OtiIntegrationPendoService(this.oneTrustIntegration.cookiePreferenceChange$, this.logService);
        this.snowplowIntegration = new oti_integration_snowplow_1.OtiIntegrationSnowplow(this.oneTrustIntegration.cookiePreferenceChange$, this.userChange$, this.logService);
        this.zendeskIntegration = new oti_integration_zendesk_service_1.OtiIntegrationZendeskService();
    }
    OtiService.prototype._isOnProduction = function (isOnProduction, productionDomain) {
        var prod = false;
        if (isOnProduction != null) {
            prod = isOnProduction;
        }
        else if (productionDomain) {
            prod = document.location.href.indexOf(productionDomain) >= 0;
        }
        return prod;
    };
    OtiService.prototype._removeCookie = function (cookieName, path, domain) {
        var cookieValue = cookieName + '=';
        cookieValue += '; expires=Thu, 01 Jan 1970 00:00:00 UTC';
        cookieValue += '; path=' + (path || '/');
        if (domain) {
            cookieValue += '; domain=' + domain;
        }
        document.cookie = cookieValue;
    };
    OtiService.prototype.initialize = function (options) {
        this.options = options || this.options;
        if (!this.options) {
            throw new Error('OTIOptions is required');
        }
        var prod = this._isOnProduction(this.options.prod_env, this.options.prod_domain);
        this.pendoIntegration.configure({ options: this.options, isOnProduction: prod });
        if (this.pendoIntegration.enabled()) {
            this.pendoIntegration.init();
        }
        this.oneTrustIntegration.configure({ options: this.options, isOnProduction: prod });
        if (this.oneTrustIntegration.enabled()) {
            this.oneTrustIntegration.init();
        }
        this.zendeskIntegration.configure({ options: this.options, isOnProduction: prod });
        if (this.zendeskIntegration.enabled()) {
            this.zendeskIntegration.init();
        }
        this.snowplowIntegration.configure({ options: this.options, isOnProduction: prod });
        if (this.snowplowIntegration.enabled()) {
            this.snowplowIntegration.init();
        }
    };
    OtiService.prototype.onCookieChanges = function (handler) {
        return this.oneTrustIntegration.cookiePreferenceChange$.subscribe(function (nextActiveGroups) {
            handler(nextActiveGroups);
        });
    };
    OtiService.prototype.openCookiePreferences = function () {
        this.oneTrustIntegration.openCookiePreferences();
    };
    OtiService.prototype.goToZendeskHelpCenter = function (helpCenterUrl) {
        return this.zendeskIntegration.goToZendeskHelpCenter(helpCenterUrl);
    };
    OtiService.prototype.printDebug = function () {
        this.oneTrustIntegration.printDebug();
    };
    OtiService.prototype.removeCookies = function (path, domain) {
        this._removeCookie('OptanonConsent', path, domain);
        this._removeCookie('OptanonAlertBoxClosed', path, domain);
    };
    OtiService.prototype.resetAnalyticsContext = function (context) {
        return this.snowplowIntegration.resetContext(context);
    };
    OtiService.prototype.setDebug = function (debug) {
        this.logService.setDebug(debug);
    };
    OtiService.prototype.trackEvent = function (evt) {
        this.snowplowIntegration.trackSnowplowStructEvent(evt);
    };
    OtiService.prototype.trackNamedEvent = function (name, props) {
        this.pendoIntegration.track({ name: name, props: props });
    };
    OtiService.prototype.trackPageView = function (evt) {
        this.snowplowIntegration.trackSnowplowPageView(evt);
    };
    OtiService.prototype.updateAnalyticsContextData = function (contextData) {
        return this.snowplowIntegration.updateContextData(contextData);
    };
    OtiService.prototype.updateVisitorPayload = function (pendoVisitorPayload, pendoDetails) {
        return this.pendoIntegration.updateVisitorPayload(pendoVisitorPayload, pendoDetails);
    };
    OtiService.prototype.updateUserId = function (userId) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.userChange$.publish(userId ? { userId: userId } : null);
            resolve();
        });
    };
    return OtiService;
}());
exports.OtiService = OtiService;
